export default ({
  config() {
    let config
    // 本地
    if (window.location.host.includes('localhost:8080')
      || window.location.host.includes('localhost:8081')
      || window.location.host.includes('.turboradio.cn')) {
      config = {
        VUE_APP_SERVER:'https://dataetc.turboradio.cn/sa.php?project=uniondrug',
        sensor_track_server:'https://ssd-etc.uniondrug.cn/sa?project=default',
      }
    }
    if (window.location.host.includes('.uniondrug.net')) {
      config = {
        VUE_APP_SERVER:'https://dataetc.uniondrug.net/sa.php?project=uniondrug',
        sensor_track_server:'https://ssd-etc.uniondrug.cn/sa?project=default',
      }
    }
    if (window.location.host.includes('.uniondrug.cn')) {
      config = {
        VUE_APP_SERVER:'https://dataetc.uniondrug.cn/sa.php?project=uniondrug',
        sensor_track_server:'https://ssd-etc.uniondrug.cn/sa?project=production',
      }
    }
    return config
  }
})
